import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
        AlertDialog,
        AlertDialogAction,
        AlertDialogCancel,
        AlertDialogContent,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogHeader,
        AlertDialogTitle,
        AlertDialogTrigger,
    } from '@/components/ui/alert-dialog';
    import { useForm } from '@inertiajs/vue3';
    import { useQueryClient } from '@tanstack/vue-query';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    import { User } from '@/types';
    import ResetPasswordButton from '@/components/ResetPasswordButton.vue';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        user: User;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  props: {
    user: {}
  },
  emits: ['error'],
  setup(__props: any, { emit: __emit }) {

    const queryClient = useQueryClient();

    const emit = __emit;

    const { t } = useI18n();

    const props = __props;

    const form = useForm({});

    const action = () => {
        form.get(route('v2.users.reset-password', props.user.id), {
            preserveScroll: true,
            onSuccess: () => {
                updateTable();
                toast.success(t(`users.js.reset.success`, { username: props.user.name }));
            },
            onError: (error) => {
                toast.error(t('forms.general.error'));
                emit('error', error);
            },
        });
    };

    const updateTable = () => {
        queryClient.invalidateQueries({ queryKey: [QueryKey.USERS] });
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AlertDialog), null, {
    default: _withCtx(() => [
      _createVNode(_unref(AlertDialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(ResetPasswordButton)
        ]),
        _: 1
      }),
      _createVNode(_unref(AlertDialogContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(AlertDialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)(`users.js.reset.title`)), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogDescription), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)(`users.js.reset.content_1`, { name: props.user.name })) + " ", 1),
                  _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(t)(`users.js.reset.content_2`)), 1)
                ]),
                _: 1,
                __: [0]
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(AlertDialogFooter), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogCancel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)(`users.js.no`)), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogAction), {
                onClick: action,
                variant: "default"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)(`users.js.yes`)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})